import React from 'react';
import { bool, func, string } from 'prop-types';

import BoxMessageInput from './BoxMessageInput';
import FileInput from './FileInput';

import s from './index.module.css';

const BoxMessage = ({
  onSend,
  onFocus,
  isWidgetPath,
  sendMessage,
  isTyping,
  onType,
  sendMessageWithFile,
  onPostFile,
  imageSrc,
  resetImagePreview,
}) => (
  <div className={s.boxMessage}>
    <FileInput
      onSendMessage={sendMessageWithFile}
      onPost={onPostFile}
      imagePreview={imageSrc}
      resetImagePreview={resetImagePreview}
    />
    <BoxMessageInput
      sendMessage={sendMessage}
      isTyping={isTyping}
      onType={onType}
      onSend={onSend}
      onFocus={onFocus}
      isWidgetPath={isWidgetPath}
    />
  </div>
);

BoxMessage.propTypes = {
  onPostFile: func,
  sendMessage: func,
  onFocus: func,
  imageSrc: string,
  sendMessageWithFile: func,
  resetImagePreview: func,
  isTyping: bool,
  isWidgetPath: bool,
  onType: func,
};

BoxMessage.defaultProps = {
  onPostFile: () => {},
  onType: () => {},
  onFocus: () => {},
  sendMessage: () => {},
  sendMessageWithFile: () => {},
  resetImagePreview: () => {},
  isTyping: false,
  isWidgetPath: false,
};

export default BoxMessage;
